export const FETCH_INPERSON_DELIVERY_REQUEST = "FETCH_INPERSON_DELIVERY_REQUEST";
export const FETCH_INPERSON_DELIVERY_SUCCESS = "FETCH_INPERSON_DELIVERY_SUCCESS";
export const FETCH_INPERSON_DELIVERY_FAILURE = "FETCH_INPERSON_DELIVERY_FAILURE";
